<template>
  <div v-if="_customer?.parent">
    <div class="d-flex align-items-center">
      <div class="text-title">Parent:</div>
      <a class="ml-1" :href="parentUrl">{{ _customer.parent.name }}</a>
      <i
        class="far fa-arrow-up-right-from-square ml-1 link"
        data-cy="parentViewIcon"
        @click="openParent"
      ></i>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import { subCustomersPath } from "@/mixins/path_helpers";
import { Customer } from "@/typings/customer";

const emit = defineEmits(["save-success"]);
const props = withDefaults(
  defineProps<{
    customer: Customer | null;
  }>(),
  { customer: null }
);
// Map props to computed to make it reactive
const _customer = computed(() => props.customer);

// This line is only to appease the compiler
// props are automatically exposed to the template
defineExpose({ customer: props.customer, emit });

function openParent() {
  location.href = parentUrl.value;
}

const parentUrl = computed(() => {
  return subCustomersPath(_customer.value?.parent?.id);
});
</script>
